
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import ServiceEnum from '@/views/dashboard/service/_components/service-enum/service-enum.vue'
import CmTag from '@/views/dashboard/_components/cm-tag.vue'
import { PriceList } from '@/views/dashboard/service/service-common.service'

export default defineComponent({
  components: {
    CmTag,
    ServiceEnum,
  },

  props: {
    serviceMerge: {
      type: Array as PropType<PriceList[]>,
      default: () => ([])
    },
  },

  setup () {
    const { t } = useI18n()

    function getGroupServicesName (group: PriceList) {
      const nameList: string[] = []
      group.service_data.forEach(categoryItem => categoryItem.service_list.forEach(v => nameList.push(v.name)))
      return nameList.join(t('subscribeDetails.includedServicesSeparator'))
    }

    return {
      t,
      getGroupServicesName,
    }
  },
})
